import React from "react";
import "./ServiceInicio.css";
// Imágenes (se mantienen pero se les aplica estilo en CSS)
import imgPlataforma from "../Assets/Img/undraw_progressive_app_m9ms.png";
import imgOnboarding from "../Assets/Img/onboarding.png";
import imgAsistencia from "../Assets/Img/undraw_Team_up_re_84ok.png";
import imgChatbot from "../Assets/Img/undraw_Artificial_intelligence_re_enpp.png";
import { Zoom } from "react-awesome-reveal";
import Effetoscroll from "../effectoscroll/effectoscroll";
// import Valores from "../effectoscroll/Valores";
function ServiceInicio() {
  const modulos = [
    {
      id: 1,
      titulo: "Plataforma educativa integral",
      descripcion:
        "Sistema completo para gestión académica, pedagógica y administrativa con comunicación en tiempo real y analíticas avanzadas.",
      imagen: imgPlataforma,
      destacado: true,
      features: [
        "Gestión escolar completa",
        "Comunicación con familias",
        "Reportes y estadísticas",
        "Acceso multiplataforma",
      ],
    },
    {
      id: 2,
      titulo: "Onboarding y reclutamiento",
      descripcion:
        "Automatiza procesos de selección, incorporación y capacitación inicial del personal con flujos inteligentes.",
      imagen: imgOnboarding,
      features: [
        "Ingreso guiado",
        "Seguimiento de progreso",
        "Evaluaciones automáticas",
      ],
    },
    {
      id: 3,
      titulo: "Asistencia técnica 24/7",
      descripcion:
        "Soporte permanente para garantizar continuidad operativa y resolución inmediata de incidencias.",
      imagen: imgAsistencia,
      features: [
        "Atención continua",
        "Resolución remota",
        "Monitoreo del sistema",
      ],
    },
    {
      id: 4,
      titulo: "Chatbot inteligente",
      descripcion:
        "Asistente virtual con IA que responde consultas en cualquier momento.",
      imagen: imgChatbot,
      features: [
        "Respuestas automáticas",
        "Disponible 24/7",
        "Integración con tu organización",
      ],
    },
  ];

  return (
    <section className="service-section" id="modulos">
      <div className="service-container">

        <header className="service-header">
          <span className="service-badge">Módulos principales</span>

          <h2 className="service-title">
            Soluciones pensadas para <span>instituciones educativas</span>
          </h2>
          <p>
            Tecnología que simplifica la gestión y potencia la experiencia educativa.
          </p>
        </header>

        <Zoom cascade damping={0.08} triggerOnce>
          <div className="service-grid">
            {modulos.map((m) => (
              <article
                key={m.id}
                className={`service-card ${m.destacado ? "service-card-featured" : ""}`}
              >
                <div className="service-image">
                  <img src={m.imagen} alt={m.titulo} />
                </div>

                <div className="service-content">
                  <h3>{m.titulo}</h3>
                  <p>{m.descripcion}</p>

                  <ul className="service-features">
                    {m.features.map((f, i) => (
                      <li key={i}>
                        <i className='bx bx-check'></i> {f}
                      </li>
                    ))}
                  </ul>

                  {m.destacado && (

                    <a
                      href="https://wa.me/message/ORWIOZ4UP74NM1"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="service-btn-secondary"
                    >
                      Conocer plataforma personalizada
                    </a>
                  )}
                </div>
              </article>
            ))}
          </div>
        </Zoom>

        {/* Sección de beneficios */}
        <div className="service-benefits">
          {/* <h3>¿Por qué elegir Tresatec?</h3> ACA */}
          {/* <div className="benefits-grid">
            <div className="benefit-item">
              <i className='bx bx-rocket'></i>
              <h4>Implementación rápida</h4>
              <p>Tu institución funcionando en semanas, no meses.</p>
            </div>
            <div className="benefit-item">
              <i className='bx bx-shield-alt'></i>
              <h4>Seguridad y confiabilidad</h4>
              <p>Protección de datos y disponibilidad garantizada.</p>
            </div>
            <div className="benefit-item">
              <i className='bx bx-trending-up'></i>
              <h4>Escalable</h4>
              <p>Crece junto con tu organización sin límites.</p>
            </div>
            <div className="benefit-item">
              <i className='bx bx-support'></i>
              <h4>Acompañamiento real</h4>
              <p>No vendemos software: construimos soluciones.</p>
            </div>
          </div> */}
        </div>

        {/* <Valores /> */}
        {/* CTA final */}
        {/* <div className="service-cta">
          <h3>¿Listo para modernizar tu institución?</h3>
          <p>Solicitá una demostración personalizada sin compromiso.</p>
          <button className="service-btn-primary">Solicitar demo</button>
        </div>  */}
      </div>
    </section>
  );
}

export default ServiceInicio;